import {
  createApiFactory,
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { entityRouteRef } from './routes';
import { codeOwnershipApiRef } from './api';
import { CodeOwnershipClient } from '@appfolio/backstage-plugin-code-ownership-common';

export { isCodeOwnershipEnabled } from './helpers';

export const codeOwnershipPlugin = createPlugin({
  id: 'appfolio-code-ownership',
  routes: {
    entity: entityRouteRef,
  },
  apis: [
    createApiFactory({
      api: codeOwnershipApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new CodeOwnershipClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const EntityCodeOwnershipContent = codeOwnershipPlugin.provide(
  createRoutableExtension({
    name: 'EntityCodeOwnershipContent',
    component: () =>
      import('./components/EntityCodeOwnershipContent').then(
        m => m.EntityCodeOwnershipContent,
      ),
    mountPoint: entityRouteRef,
  }),
);

export const EntityCodeOwnershipCard = codeOwnershipPlugin.provide(
  createComponentExtension({
    name: 'EntityCodeOwnershipCard',
    component: {
      lazy: () =>
        import('./components/EntityCodeOwnershipCard').then(
          m => m.EntityCodeOwnershipCard,
        ),
    },
  }),
);

export const EntityRefCodeOwnershipLink = codeOwnershipPlugin.provide(
  createComponentExtension({
    name: 'EntityRefCodeOwnershipLink',
    component: {
      lazy: () =>
        import('./components/EntityRefCodeOwnershipLink').then(
          m => m.EntityRefCodeOwnershipLink,
        ),
    },
  }),
);
